export default __webpack_public_path__ + "static/media/autoDBWhiteLogo.e6cbd5b1.svg";